"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidObject = void 0;
const is_defined_1 = require("../../is-defined");
function isValidObject(obj) {
    return (0, is_defined_1.isDefined)(obj) && typeof obj == 'object' && !Array.isArray(obj);
}
exports.isValidObject = isValidObject;
